import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
`;
